<template>
  <div class="home"
       style="margin-top:6.5rem">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true">
    </loading>
    <TopAlert></TopAlert>
    <b-card class="poster"
            v-show="postUrl && isShowPoster">
      <div class="poster-container">
        <div style="position:relative;">
          <div @click="enterEvent()">
            <img :src="posterImage"
                 class="poster-img">
          </div>
          <img class="poster-close"
               @click="closePoster"
               src="static/images/close.svg">
        </div>
      </div>
    </b-card>
    <div class="video-container">
      <VideoList></VideoList>
    </div>
  </div>
</template>

<script>

import CovidMap from '@/components/CovidMap'
import VideoList from '@/components/VideoList'
import TopAlert from '@/components/TopAlert'
import Header from '@/components/Header'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters, mapActions } from 'vuex'
import { POST_URL } from '@/constants'
import { getPoster } from '@/utils/api'

export default {
    data() {
        return {
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            showMobileAppAlert: process.env.PLATFORM !== 'mobile_app',
            postUrl: POST_URL === 'api' ? '' : POST_URL,
            loading: false,
            posterImage: 'static/images/poster-sp.jpg'
        }
    },
    created() {
        if (this.isShowPoster && POST_URL === 'api') {
            getPoster().then(res => {
                if (res.data.code === 0 && res.data.show_poster) {
                    this.postUrl = res.data.event_url
                    this.posterImage = res.data.poster_img
                }
            }).catch(() => { console.log('Failed to get Poster') })
        }
    },
    methods: {
        ...mapActions(['setUserInfo', 'setUserBalance', 'closePoster']),
        enterEvent() {
            if (this.postUrl.startsWith('http://') || this.postUrl.startsWith('https://')) {
                let target = this.isMobileApp ? '_system' : '_blank'
                window.open(this.postUrl, target)
            } else {
                this.$router.push({ path: this.postUrl })
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'userBalance', 'currentVideo', 'isShowPoster'])
    },
    components: {
        Header,
        CovidMap,
        VideoList,
        TopAlert,
        Loading
    }
}
</script>
<style scoped>
.poster {
  position: fixed;
  z-index: 19999;
  background-color: transparent;
  border: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.poster-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.poster-img {
  height: 75vh;
}
.poster-close {
  cursor: pointer;
  height: 3vh;
  position: absolute;
  right: -4vh;
  top: -4vh;
}
.tab-content {
    margin: 40px 5px;
}
.social-login-icon {
    width: 64px;
    height: 64px;
    margin-left: 20px;
    margin-right: 20px;
}
.video-container {
    width: 100%;
    margin: 0 auto;
}
.hide {
    display: none;
}
@media only screen and (max-width:768px) {
  .poster-img {
    width: 80vw;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue